module.exports = __webpack_public_path__ + "static/media/lastlogindetails.4aafac73.svg";